var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7Tmx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 152,
    viewBox: "0 0 170 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1347 99.6024L28.1141 96.7218V58.1588H42.1711V52.444H0L1.45256 58.1588H15.1347V99.6024Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8108 52.444C81.6714 60.6212 78.6257 68.8914 74.7366 76.2323C71.3161 68.3338 68.2235 60.1566 64.6624 52.444H50.7928V98.1621H58.1493V67.8692L71.6441 97.6975L84.8108 68.5197V98.1621H97.7902V52.444H84.8108Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.528 39.5277H152.191C155.33 26.8901 156.923 13.9738 156.923 0.9646L146.053 5.28552C144.038 74.792 94.1353 132.451 27.8798 146.854L26.521 151.035C55.291 145.181 81.812 131.289 102.898 111.032H115.502L132.089 87.4295L148.677 111.032H169.575L141.929 75.3031L169.528 39.5277Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.497 63.7806L118.923 52.444H104.491L121.687 74.6526C123.983 71.2609 125.951 67.5904 127.497 63.7806Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Tmx);
export default __webpack_public_path__ + "static/media/7_tmx.53a1496f7dcb206de277da28289ab1b8.svg";
export { ForwardRef as ReactComponent };